import { createRoute } from '@/utils/routing'

export const CLIENT_REQUEST_LIST_ROUTE = 'client-requests'
export const CLIENT_REQUEST_VIEW_ROUTE = 'client-requests-clientRequestId'
export const CLIENT_REQUEST_CREATE_ROUTE = 'client-requests-create'

export function createClientRequestListRoute (options = {}) {
  return createRoute(CLIENT_REQUEST_LIST_ROUTE, options)
}

export function createClientRequestViewRoute (clientRequestId, profileId, options = {}) {
  if (clientRequestId != null && profileId != null) {
    return createRoute(CLIENT_REQUEST_VIEW_ROUTE, {
      params: { ...options.params, clientRequestId },
      query: { ...options.query, profileId }
    })
  }
}

export function createClientRequestCreateRoute (options = {}) {
  return createRoute(CLIENT_REQUEST_CREATE_ROUTE, options)
}
